export default __webpack_public_path__ + "static/media/Paddy.bdc634ea.jpg";